import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-nfl-product',
  templateUrl: './nfl-product.component.html',
  styleUrls: ['./nfl-product.component.css']
})
export class NflProductComponent implements OnInit {

  constructor(public router: Router) { }

  navigateToSignup() {
    localStorage.setItem("isFrom", "nflProduct")
    this.router.navigateByUrl("/landing/signup")
  }

  ngOnInit() {

  
		$(document).ready(function(){
   $(".testimonials-carousasdel").owlCarousel({
    autoplay: true,
    dots: true,
    loop: true,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      900: {
        items: 3
      }
    }
  });

			
  $(".clients-asdcarousel").owlCarousel({
    autoplay: true,
    dots: true,
    loop: true,
    responsive: { 
      0: {
        items: 1
      },
      768: {
        items: 3
      },
      900: { 
        items: 3
      }
    }
  });
  
});		 	




  }

}
